import { render, staticRenderFns } from "./ViewChromeProfile.vue?vue&type=template&id=aaa68024"
import script from "./ViewChromeProfile.vue?vue&type=script&lang=js"
export * from "./ViewChromeProfile.vue?vue&type=script&lang=js"
import style0 from "./ViewChromeProfile.vue?vue&type=style&index=0&id=aaa68024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports